import { Injectable, Injector } from '@angular/core';
import { 
  HttpRequest, 
  HttpHandler, 
  HttpEvent, 
  HttpInterceptor, 
  HttpErrorResponse 
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { AlertModalComponent } from '../components/alert-modal/alert-modal.component'; 

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    // 🟢 NOVO: Criamos uma regra para ignorar as requisições dos aparelhos Bluetooth/Locais.
    const isMeasurerRequest = 
        request.url.includes('BloodPressure') || 
        request.url.includes('Glucometer') || 
        request.url.includes('Oximeter') || 
        request.url.includes('Thermometer') ||
        request.url.includes('/scan') || // API Bluetooth
        request.url.includes('/connect') || // API Bluetooth
        request.url.includes('/clear'); // API Bluetooth

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        
        // 🟢 NOVO: Se o erro veio de um aparelho médico, a gente NÃO ABRE o modal global.
        // Apenas devolvemos o erro para o `UtilsMeasurerService` lidar com o alerta específico dele.
        if (isMeasurerRequest) {
          return throwError(() => error);
        }

        const dialog = this.injector.get(MatDialog);
        
        // 1. Define um ID único para o nosso modal de erro global
        const errorDialogId = 'global-error-modal';

        // 2. Trava de segurança: Se o modal já estiver na tela, apenas repassa o erro e cancela a abertura de um novo
        if (dialog.getDialogById(errorDialogId)) {
          return throwError(() => error);
        }

        // 3. Verifica se o erro é de rede/timeout da API Principal (Cenário 1)
        const isInstability = 
          error.status === 504 || 
          error.status === 0 || 
          (error.error && error.error.errorCode === 'ERR_NETWORK_TIMEOUT');

        if (isInstability) {
          // Exibe modal de Instabilidade
          dialog.open(AlertModalComponent, {
            id: errorDialogId, // <-- Garante que o modal receba o ID único
            disableClose: true, 
            data: {
              title: 'Instabilidade Temporária',
              description: 'Estamos enfrentando uma lentidão temporária no processamento das informações.',
              description2: 'Por favor, aguarde alguns instantes e tente novamente.',
              hasImage: true,
              isTwoButtonsModal: false,
              textButtonCancel: 'Fechar'
            }
          });
        } 
        else if (error.status === 500) {
          // Exibe modal de Erro Interno (Banco caiu, etc)
          dialog.open(AlertModalComponent, {
            id: errorDialogId,
            disableClose: true,
            data: {
              title: 'Erro Interno',
              description: error.error?.detail || 'Ocorreu um erro inesperado na operação.',
              description2: 'Nossa equipe técnica já foi notificada.',
              hasImage: true,
              isTwoButtonsModal: false,
              textButtonCancel: 'Fechar'
            }
          });
        }

        // 4. Retorna o erro de forma silenciosa para o resto do sistema
        return throwError(() => error);
      })
    );
  }
}